export default __webpack_public_path__ + "static/media/portfolio-127.e0af0543.jpg";